export default __webpack_public_path__ + "b13251a14ed2654333cad5754e41367d.png";